/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LookupMappings
 */
export interface LookupMappings {
    [key: string]: string;
}


/**
 * Check if a given object implements the LookupMappings interface.
 */
export function instanceOfLookupMappings(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LookupMappingsFromJSON(json: any): LookupMappings {
    return LookupMappingsFromJSONTyped(json, false);
}

export function LookupMappingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupMappings {
    return json;
}

export function LookupMappingsToJSON(value?: LookupMappings | null): any {
    return value;
}

